"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventFromReceipt = void 0;

var _ethers = require("ethers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ethers = _objectSpread({}, _ethers.ethers);

if (ethers.version.startsWith("6.")) {
  ethers.utils = {
    Interface: ethers.Interface
  };
  ethers.ContractReceipt = ethers.TransactionReceipt;
}

const getEventFromReceipt = (receipt, topic, iface) => {
  if (ethers.version.includes("/5")) {
    if (!receipt.events) throw new Error("Events object is undefined");
    const event = receipt.events.find(evt => evt.topics[0] === topic);
    if (!event) throw new Error(`Cannot find topic ${topic}`);
    if (iface) return iface.parseLog(event);
    return event;
  }

  if (ethers.version.startsWith("6")) {
    const resLog = receipt.logs.find(log => {
      var _iface$parseLog;

      return ((_iface$parseLog = iface.parseLog(log)) === null || _iface$parseLog === void 0 ? void 0 : _iface$parseLog.name) === topic;
    });
    return iface.parseLog(resLog);
  }

  throw new Error("Unsupported ethers version");
};

exports.getEventFromReceipt = getEventFromReceipt;